import { createContext } from 'react';

export type MediaName = 'mobile' | 'tablet' | 'desktop';
export type ScrollPosition = 'top' | 'scrolled-top';

interface Context {
    currentMediaName: MediaName;
    isMobile: () => boolean;
    scrollPosition: ScrollPosition;
}

export const WindowContext = createContext<Context>(undefined!);
